import React from 'react'

const Safaltakokatha = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका योगसँग सम्बन्धित पारिभाषिक शब्दको अर्थ शब्दकोशका सहायताले लेख्नुहोस् :</h5>
        <p>यम : आठवटा योगमध्यको पहिलो चरण वा योग</p>
        <p>नियम : अनुशासन</p>
        <p>आसन : बस्ने ठाउँ</p>
        <p>प्रणायाम : श्वास प्रश्वासमा लयवद्धताका साथ गरिने योग</p>
        <p>प्रत्याहार : अष्टाङ्ग योग मध्यको पाँचौ योग</p>
        <p>धारणा : विचार</p>
        <p>ध्यान : चित्त एकाग्र पार्ने साधना योगमा रहने मनको स्थिति</p>
        <p>समाधि : ब्रह्मा चिन्तनमा केन्द्रित हुने योग साधनाको आठौं वा अन्तिम अवस्था</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका अर्थसँग मिल्ने शब्द पाठबाट खोजेर लेख्नुहोस् :</h5>
        <p>(क) हलचल नगर्ने : स्थिर</p>
        <p>(ख) ओइलाएको : मलिन</p>
        <p>(ग) बौद्धस्मारक : स्तूप</p>
        <p>(घ) प्राचीन चिकित्साशास्त्र : आयुर्वेद</p>
        <p>(ङ) एकचित्त : एकाग्रता</p>
        <p>(च) कथाहिनता : अकथा</p>
        <p>(छ) एम.ए. वा सो सरह : स्नातकोत्तर</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका शब्दहरुलाई अर्थ खुल्ने गरी वाक्य बनाउनुहोस् :</h5>
        <h5>व्यग्र</h5>
        <p>परिक्षाको नतिजा हेर्ने अवसर नजिकिँदै जाँदा विद्यार्थीहरू व्यग्र भएर पर्खिरहेका थिए।</p>
        <h5>चैत्य</h5>
        <p>स्वयम्भूनाथमा बनेको प्राचीन चैत्य बौद्ध धर्मावलम्बीहरूको आस्थाको केन्द्र हो।</p>
        <h5>योग</h5>
        <p>नियमित योग गर्दा शरीर स्वस्थ र मन शान्त रहन्छ।</p>
        <h5>स्नातक</h5>
        <p>उसले त्रिभुवन विश्वविद्यालयबाट स्नातक तहको अध्ययन पुरा गर्‍यो।</p>
        <h5>मनोचिकित्सा</h5>
        <p>दीर्घकालीन तनावका कारण उसले मनोचिकित्सा लिइरहेको छ।</p>
        <h5>समग्रता</h5>
        <p>राष्ट्रिय विकासका लागि शिक्षा, स्वास्थ्य, कृषि, र पूर्वाधारको समग्रता आवश्यक हुन्छ।</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. दिइएक प्रश्नहरूको उत्तर दिनुहोस् :</h5>
        <h5>(क) रिपोर्ताज कुन विषयमा लेखिएको छ ?</h5>
        <p>= रिपोर्ताज योग साधना र यसको फाइदाको बारेमा लेखिएको छ ।</p>
        <h5>(ख) रिपोर्ताजमा कति जना व्यक्तिको नाम उल्लेख भएको छ ?</h5>
        <p>= रिपोर्ताजमा अमित, सुन्दर र युगेन्द्र गरि तीन जना व्यक्तिको नाम उल्लेख भएको छ ।</p>
        <h5>(ग) रिपोर्ताज कतिओटा अनुच्छेदमा संरचित छ ?</h5>
        <p>= रिपोर्ताज २५ अनुच्छेदमा संरचित छ ।</p>
        <h5>(घ) रिपोर्ताजमा प्रयुक्त भाषाशैली कस्तो छ ?</h5>
        <p>= रिपोर्ताजमा प्रयुक्त भाषाशैली निजात्मक छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>३. पाठका आधारमा जोडा मिलाउनुहोस् :</h5>
        <p>(क) अमित ठाकुर - पत्रकार</p>
        <p>(ख) सुन्दर छन्त्याल - योगसाधनाका कारण पुनजीवन र सफलता पाउने व्यक्ति</p>
        <p>(ग) रत्न राज्यलक्ष्मी - अमित ठाकुरले पत्रकारिता पढेको क्याम्पस</p>
        <p>(घ) धुलिखेल - अमित ठाकुर फिचर स्टोरी खोज्न गएको ठाउँ</p>
        <p>(ङ) आरुबारी - काठमाडौमा सुन्दर छन्त्यालहरुको बसोबास रहेको ठाउँ</p>
        <p>(च) म्याग्दी - सुन्दरको जन्मथलो</p>
        <p>(छ) हृदयघात - सुन्दरका पिताको मृत्युको कारण</p>
        <p>(ज) क्यान्सर - सुन्दर छन्त्यालकी आमालाई लागेको रोग</p>
        <p>(झ) तौलिहवा - अमित ठाकुरको घर भएको ठाउँ</p>
      </div>
      <hr/>
      <div>
        <h5>४. " योग ध्यान …….. ताँती सुरु भयो "रिपोर्ताजको अंश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) ध्यान गर्नका लागि म पात्र कहाँ कहाँ पुगेको थियो ?</h5>
        <p>= ध्यान गर्नका लागि म पात्र लुम्बिनीको स्तूप, चैत्य, पिपलको बोटमुनि, देवालयको खुला मैदान, पशुपती आदि ठाउँहरुमा पुगेका थिए ।</p>
        <h5>(ख) गोठाटारले म पात्रलाई किन आकर्षित गर्छ ?</h5>
        <p>= गोठाटारको शान्त, एकान्त र योगसाधनाको लागि अनुकुल वातावरणले म पात्रलाई आकर्षित गर्छ ।</p>
        <h5>(ग) "हजारौं माइलको यात्रा एक सानो पाइलाबाट सुरु हुन्छ ।" भन्नुको तात्पर्य के हो ?</h5>
        <p>= कुनै पनि महान कार्य वा ठुला ठुला कामको सुरुवात सानो योजनाबाट नै हुन्छ भन्नुनै हजारौं माइलको यात्रा एक सानो पाइलाबाट सुरु हुन्छ भन्नू हो ।</p>
        <h5>(घ) योगले मानव जीवनलाई कसरी परिवर्तन गर्छ ?</h5>
        <p>= योगले मनलाई एकाग्रता बनाई, नयाँ ऊर्जा र सकारात्मक सोच दिने भएकाले जीवनलाई परिवर्तन गर्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएको रिपोर्ताजको अंश पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) सुन्दर छन्त्यालमा कसरी बाँच्ने इच्छाशक्ति जागृत भयो ?</h5>
        <p>= योग र साधनाले मनमा रहेका विकारहरु हटाएकोले उनमा नयाँ सोच, चेतना, प्राणायाम, प्रत्याहार, धारणा र ध्यान हुँदै समाधिको यात्रा तय गरिने कुरा बुझेकाले मनको विकार हट्दै गई सुन्दर छन्त्यालमा बाँच्ने इच्छाशक्ति जागृत भयो ।</p>
        <h5>(ख) योग साधनाले मानव स्वास्थमा पार्ने प्रभावहरु के के हुन् ?</h5>
        <p>= योग साधनाले मानव स्वास्थमा पार्ने प्रभावहरु थुप्रै छन् । योग साधनाले मनलाई एकाग्र बनाइ चिन्तन र ज्ञानको विकास गर्नुका साथै मनका विकार हटाउन मद्दत गर्छ । योग चिन्तन, मनको एकाग्रता र समाधि तर्फको यात्रा हो । योगले नै मनको विकार हटाई आत्मिक एवं भौतिक शान्ति दिलाई सुखी र निरोगी जीवन बाँच्ने आधार खडा गर्दछ । योगले सहनशीलता, दुरगामि सोच र उदार विचार जस्ता जीवनोपयोगी कलाको विकास गर्दछ ।</p>
      </div>
      <hr/>
      <div>
        <h5>७. उत्तर लेख्नुहोस् :</h5>
        <h5>(क) रिपोर्ताजमा प्राकृतिक परिवेशको वर्णन कसरी भएको छ ?</h5>
        <p>= रिपोर्ताजमा प्राकृतिक परिवेशलाई मानिसको मनको शान्तिसँग तुलना गर्दै आकर्षक रूपमा वर्णन गरिएको छ। जङ्गल, एकान्त स्थल, चउर, आरुबारी आदि स्थानलाई शान्त, एकाग्रचित्त हुने र ज्ञान प्राप्त गर्न सकिने स्थलका रूपमा चित्रित गरिएको छ। पात्र अमितलाई गोठाटार मन पर्नुको मुख्य कारण त्यहाँको शान्त, हरियाली र प्राकृतिक वातावरण हो।</p>
        <p>रिपोर्ताजमा सुन्दरको घरबाट देखिने पहाडी चुचुरो, घामले झुल्किएको आरुबारी, अनि त्यहाँको हरियाली दृश्यले पाठकको मन तान्ने प्रकारको प्राकृतिक चित्रण प्रस्तुत गरिएको छ। लेखकले शान्त परिवेशको प्रभाव पात्रहरूको मनोविज्ञानमा पार्ने सकारात्मक असर पनि देखाएका छन्।
यसरी रिपोर्ताजमा प्राकृतिक परिवेशलाई सुन्दर, शान्त र मोहक रूपमा मानवीकरण गर्दै वर्णन गरिएको छ।</p>
        <h5>(ख) सुन्दर छन्त्यालको सफलताको कथा सङ्क्षिप्त रुपमा लेख्नुहोस् ।</h5>
        <p>= सुन्दर छन्त्याल मध्यमवर्गीय परिवारमा जन्मेका, सरकारी अधिकृत बुबा र शिक्षक आमाका एक मात्र सन्तान हुन्। काठमाडौंको प्रतिष्ठित विद्यालयबाट एस.एल.सी. पास गरी विज्ञान विषयमा उच्च माध्यमिक तह उत्तीर्ण गरेका उनले सिभिल इन्जिनियरिङमा स्नातक गरेका थिए। बाबुको अकस्मात् निधन र आमामा क्यान्सरको पत्ता लागेपछि उनको जीवनमा ठूलो संकट आयो।दिल्लीमा आमाको उपचार गर्दा धेरै ऋण भयो र जमिन बेच्नुपर्‍यो। मानसिक रूपमा कमजोर बन्दै गएका सुन्दरले एक दिन डा. युरेन्द्र झाको चिकित्सा केन्द्रमा गएर योग र ध्यान गर्न थाले। त्यसपछि उनलाई मानसिक शान्ति मिल्यो र बाँच्ने इच्छाशक्ति जागृत भयो।लगनशीलता, आत्मविश्वास र निरन्तर प्रयासले उनले प्राविधिक अधिकृत पदमा सफलता हासिल गरे। यसरी उनी दुःख, निराशा र तनाव पार गर्दै सफल जीवन बिताउन सक्षम भए।</p>
        <h5>(ग) पाठको मुख्य उद्देश्य के हो ?</h5>
        <p>= यस पाठको मुख्य उद्देश्य जीवनमा आइपर्ने समस्या, दुःख र तनावसँग आत्मबल, एकाग्रता र सकारात्मक सोचद्वारा सामना गर्न सकिन्छ भन्ने सन्देश दिनु हो। जीवनमा सुख–दुःख घाम–छायाँझैं आइरहन्छन्, तर त्यसबाट डराउनु हुँदैन। शान्त र स्थिर मनका साथ योग र ध्यानमार्फत शारीरिक तथा मानसिक सन्तुलन कायम गर्न सकिन्छ। मनलाई बुझाउने, स्वीकार गर्ने र इच्छाशक्ति जागृत गराउने उपायहरूमार्फत जीवनलाई सहज र सफल बनाउने उपाय सुझाउनु नै यस पाठको मूल उद्देश्य हो।</p>
      </div>
      <hr/>
      <div>
        <h3>८. व्याख्या गर्नुहोस् :</h3>
        <h5>(क) यो स्मृति भन्ने वस्तु पनि रमाइलो छ । स्मृतिले नै शब्दलाई जोड्छ र भत्काउँछ । स्मृतिले मानिसलाई मानिस बनाउँछ र पुनर्जीवित गर्छ ।</h5>
        <p>= प्रस्तुत गद्यांश कक्षा ११ को नेपाली पाठ्यपुस्तकमा समावेश ‘सफलताको कथा’ शीर्षकको रिपोर्ताजमूलक रचनाबाट साभार गरिएको हो। यस रचनामा योग, ध्यान र स्मृति जस्ता मनोवैज्ञानिक पक्षहरूमार्फत मानिसले आत्मशुद्धि र लक्ष्यप्राप्ति गर्न सक्ने सन्देश दिइएको छ।</p>
        <p>गद्यांशमा स्मृति अर्थात् विगतका अनुभवहरूको सम्झनालाई मानिसको जीवनमा अत्यन्त महत्त्वपूर्ण तत्वका रूपमा चित्रण गरिएको छ। स्मृतिले व्यक्तिको सोच, भावनात्मक स्थिति र कार्यसम्पादनमा प्रभाव पार्छ। स्मृतिले मानिसलाई विगतबाट पाठ सिक्न, आत्मसुधार गर्न र नयाँ जीवनशैलीतर्फ अग्रसर हुन प्रेरणा दिन्छ। यस रचनामा पात्र अमित विगतका घटनाबाट उत्पन्न स्मृतिबाट प्रेरित भई नयाँ ढङ्गले जीवनलाई अगाडि बढाउँछ।</p>
        <p>अन्ततः, स्मृतिले मानिसलाई भूत, वर्तमान र भविष्यसँग जोड्ने भावनात्मक पुलको काम गर्छ भन्ने सन्देश यस अंशमा व्यक्त गरिएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>(ख) मनको शान्ति खोज्न टाढा जानुपर्दैन, यो तपाईं भित्रै छ । योगबाट यो प्राप्त हुन्छ ।</h5>
        <p>= प्रस्तुत गद्यांश कक्षा ११ को नेपाली पाठ्यपुस्तकमा समावेश ‘सफलताको कथा’ शीर्षक रिपोर्ताजमूलक रचनाबाट लिइएको हो। यसमा योग, ध्यान र मानसिक शान्ति को महत्त्वलाई उजागर गरिएको छ।</p>
        <p>गद्यांशले मानसिक शान्ति कुनै बाह्य वस्तु होइन, त्यो हरेक व्यक्तिको भित्रै हुने कुरा हो भन्ने सन्देश दिन्छ। जब व्यक्ति परिस्थितिसँग सहमत हुन सक्दैन, तब चिन्ता, तनाव र मानसिक असन्तुलन उत्पन्न हुन्छ। यस्तो मानसिक विकारलाई हटाउन योग र ध्यान प्रभावकारी साधन हुन्। ध्यानले मनको गहिरो शान्ति दिन्छ भने योगले शारीरिक स्वास्थ्य सुधार गर्छ। योग साधनाले मन एकाग्र, स्थिर र सकारात्मक बन्छ। त्यसैले मानसिक तथा शारीरिक तन्दुरुस्तीका लागि योग आवश्यक छ।</p>
        <p>समग्रमा, व्यक्ति भित्रै भएको शान्तिलाई महसुस गर्न, आत्मबोध गर्न र जीवनलाई सन्तुलित बनाइ सुखी ढंगले अगाडि बढाउन योग मार्ग अपनाउनु पर्छ भन्ने आशय यस गद्यांशमा व्यक्त गरिएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>९. दिइएको अनुच्छेद पढी सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) स्वस्थ हुनु भनेको के हो ?</h5>
        <p>= स्वस्थ हुनु भनेको रोग वा दुर्बलताको अभाव मात्र नभएर शारीरिक, मानसिक र सामाजिक रुपले पूर्ण तन्दुरुस्तीको अवस्था हो ।</p>
        <h5>(ख) देशका नागरिकको स्वास्थ्य स्थिति कुन कुन कुरामा निर्भर हुन्छ ?</h5>
        <p>= देशका नागरिकको स्वास्थ्य स्थिति सुर्तीजन्य पदार्थको प्रयोगको स्थिति, उच्च रक्तचाप तथा मोटोपनको स्थिति, शुद्ध पानीको उपलब्धता, औसत आयु कुपोषणग्रस्त जनसङ्ख्याको प्रतिशतका साथै मृत्युको अवस्था आदि कुरामा निर्भर हुन्छ ।</p>
        <h5>(ग) चिकित्सा विज्ञान कसरी रोकथामतिर पनि केन्द्रित हुन थालेको छ ?</h5>
        <p>= चिकित्सा विज्ञान विभिन्न किसिमका खोप, जनहितमा जारी हुने विभिन्न जनस्वास्थ्यसम्बन्धी सूचना, जानकारी, तालिम आदिको व्यवस्था गरी रोकथामतिर पनि केन्द्रित हुन थालेको छ ।</p>
        <h5>(घ) चिकित्सा विज्ञानमा कुन कुराले वढी महत्त्व पाएको छ ?</h5>
        <p>= चिकित्सा विज्ञानमा रोकथामलाई भन्दा रोग लागिसकेपछि उपचार गर्ने कुराले बढी महत्त्व पाएको छ ।</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण</h3>
        <h5>१. दिइएको अनुच्छेद पढी रेखंकिन गरिएको शब्दहरु टिपेर तिनको निर्माण प्रक्रिया देखाउनुहोस् :</h5>
        <p>लेखक: लेख् + अक</p>
        <p>पाठक: पाठ् + अक</p>
        <p>भावक: भू + अक</p>
        <p>आदरणीय: आदृ + अनीय</p>
        <p>सम्माननीय: 	सम्मान् + अनीय</p>
        <p>भौगोलिक: भूगोल + इक</p>
        <p>सम्मानित: सम्मान + इत</p>
        <p>शिक्षत: शिक्षा + इत</p>
        <p>प्राचिन: प्राच् + ईन</p>
        <p>आधुनिक: अधुना + इक</p>
        <p>नविन: नव + इन</p>
        <p>तल्लिन: तल् + इन</p>
        <p>पुजनीय: पूज् + अनीय </p>
        <p>माननीय: मान् + अनीय</p>
        <p>बालक: बाल + अक</p>
        <p>काव्य: कवि + य</p>
        <p>कारण: कृ + अन </p>
        <p>श्रेष्ठतम: श्रेष्ठ + तम</p>
        <p>गन्तव्य: गम् + तव्य</p>
        <p>हास्य: हास् + य</p>
        <p>वक्ता: वच् + ता </p>
        <p>गतिवान्:गति + वान्</p>
        <p>व्यक्तित्व: व्यक्ति + त्व</p>
        <p>कवित्व: 	कवि + त्व </p>
        <p>लेखकत्व: लेखक + त्व</p>
        <p>सिद्धत्व: सिद्ध + त्व</p>
        <p>क्षमतावान्: क्षमता + वान्</p>
        <p>बुद्धिमान्: बुद्धि + मान्</p>
        <p>किर्तिमान: कीर्ति + मान्</p>
        <p>भावमय: भाव + मय</p>
        <p>रहस्यमय: रहस्य + मय</p>
        <p>लेखकत्व: लेखक + त्व</p>
        <p>दयालु: दया + आलु</p>
        <p>लालित्य: ललित + य</p>
        <p>माधुर्य: मधुर + य</p>
        <p>लेखनी: लेखन + ई</p>
      </div>
      <hr/>
      <div>
        <h5>२. ‘सफलताको कथा’ पाठबाट दशओटा शब्दहरु टिप्नुहोस र ती शब्दहरुको निर्माण प्रक्रिया देखाउनुहोस् :</h5>
        <p>जीवन + ई: जीवनी</p>
        <p>उत्साह + इत: उत्साहित </p>
        <p>समर्पण + इत: समर्पित</p>
        <p>थाक् + आइ: थकाइ</p>
        <p>प्राचीन + पन: प्राचीनपन</p>
        <p>काट + एर: काटेर</p>
        <p>कृ + अन: कारण</p>
        <p>लिख् + अक: लेखक</p>
        <p>लेखक + इय: लेखकीय</p>
        <p>स्मृ + ति: स्मृति</p>
      </div>
      <hr/>
      <div>
        <h5>३. दिइएका प्रत्यय लगाई दुई दुईओटा शब्द निर्माण गर्नुहोस् :</h5>
        <strong>अक</strong>
        <p>लेखक(लिख्+अक)</p>
        <p>नर्तक (नृत्+अक)</p>
        <strong>अन</strong>
        <p>दर्शन (दृश्+अन)</p>
        <p>भोजन (भुज्+अन)</p>
        <strong>अनीय</strong>
        <p>दर्शनीय(दृश्+अनीय)</p>
        <p>पूजनीय(पूज्+अनीय)</p>
        <strong>इक</strong>
        <p>शैक्षिक(शिक्षा+इक)</p>
        <p>मौखिक (मुख+इक)</p>
        <strong>इत</strong>
        <p>लिखित (लिख्+इत)</p>
        <p>रचित (रच्+इत)</p>
        <strong>ई</strong>
        <p>धनी (धन+ई)</p>
        <p>नेपाली (नेपाल+ई)</p>
        <strong>ईन</strong>
        <p>युगीन (युग + ईन)</p>
        <p>कुलीन (कुल + ईन)</p>
        <strong>ईय</strong>
        <p>	केन्द्रीय (केन्द्र+ईय)</p>
        <p>आत्मीय (आत्मा+ईय)</p>
        <strong>क</strong>
        <p>बालक (वाल+क)</p>
        <p>शीर्षक(शीर्ष+क)</p>
        <strong>तर</strong>
        <p>बृहत्तर (बृहत्+तर)</p>
        <p>उत्तर (उत्+तर)</p>
        <strong>तम</strong>
        <p>उच्चतम (उच्च+तम)</p>
        <p>प्रियतम(प्रिय+तम)</p>
        <strong>तव्य</strong>
        <p>गन्तब्य (गम्+तब्य)</p>
        <p>मन्तब्य (मन्+तब्य)</p>
        <strong>ता</strong>
        <p>कर्ता (कृ+ता)</p>
        <p>श्रोता(श्रु+ता)</p>
        <strong>ति</strong>
        <p>स्मृति (स्मृ+ति)</p>
        <p>गति(गम्+ति)</p>
        <strong>त्व</strong>
        <p>मानवत्व (मानव+त्व)</p>
        <p>पुरुषत्व (पुरुष+त्व)</p>
        <strong>मय</strong>
        <p>जलमय (जल+मय)</p>
        <p>रहस्यमय (रहस्य+मय)</p>
        <strong>वान</strong>
        <p>गुणवान् (गुण वान्)</p>
        <p>वलवान् (वल+वान्)</p>
        <strong>मान्</strong>
        <p>गुणवान् (गुण+वान्)</p>
        <p>बलवान् (बल+वान्)</p>
        <strong>य</strong>
        <p>काव्य (कवि+य)</p>
        <p>माधुर्य (मधुर+य)</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएका शब्दहरुको निर्माण प्रक्रिया देखाउनुहोस् :</h5>
        <p>नी + अक: नायक</p>
        <p>शुद्ध + ता: 	शुद्धता</p>
        <p>गुरु + त्व: गुरुत्व</p>
        <p>व्यवस्था + इत: व्यवस्थित</p>
        <p>द्विपक्ष + ईय: द्विपक्षीय</p>
        <p>आयुष् + मान्: आयुष्मान्</p>
        <p>विदेश + इक: वैदेशिक</p>
        <p>गरिमा + मय: गरिमा + मय</p>
        <p>सुन्दर + य: सौन्दर्य</p>
        <p>गम् + ति: गति</p>
        <p>कृ + अक: कारक</p>
        <p>धीर + य: धैर्य</p>
        <p>युज् + ई: योगी </p>
        <p>श्रेष्ठ + तम: श्रेष्ठतम</p>
        <p>पशु + इक: पाशविक </p>
        <p>पञ्च + क: पञ्चक</p>
        <p>सूर्य + य: सौर्य </p>
        <p>वित्त + इय: वित्तीय</p>
        <p>चाट् + अनी: चटनी</p>
        <p>हात + इयार: हतियार</p>
        <p>वोल् + अक्कड: वोलक्कड </p>
        <p>दुध + आलु: दुधालु</p>
        <p>पूर्व + एली: पुर्वेली</p>
        <p>मूर्ख + याइँ: मुख्याइँ</p>
        <p>गाँजा + अडी: गँजडी</p>
        <p>पानी + एरो: पँधेरो</p>
      </div>
      
    </div>
  )
}

export default Safaltakokatha
